// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  jsonHeader,
  postMethod,
  multipartJsonHeader,
}                     from '../fetchTools';

var options = {...defaultOptions, ...jsonHeader};
export const getSessionPlanData = (name, params) => {
    console.log("sh get API ")
    console.log(name);
    console.log(params);
    if (params == null || params == "?"){
        params="";
    }
    let url = "";
    if (params == ""){
        url = `${getLocationOrigin(2)}/${appConfig.sessionPlans.data.API}${appConfig.sessionPlans.data[name].path}/${params}`
        console.log(url);
    }
    else {
        if (name == "get"){
            url = `${getLocationOrigin(2)}/${appConfig.sessionPlans.data.API}${appConfig.sessionPlans.data[name].path}/${params}/`
            console.log(url);
        }
        else{
            url = `${getLocationOrigin(2)}/${appConfig.sessionPlans.data.API}${appConfig.sessionPlans.data[name].path}/${params}`
            console.log(url);
        }
    }
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const postSessionPlanData = (name, payload) => {
    console.log("sh post API ")
    console.log(name)
    console.log(payload)
    const url = `${getLocationOrigin(2)}/${appConfig.sessionPlans.data.API}${appConfig.sessionPlans.data[name].path}/`
  var options = {...defaultOptions, ...postMethod, ...multipartJsonHeader};
  options.method = 'post';
  options.body = payload;
  console.log(options)
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const deleteSessionPlanData = (name, payload) => {
    console.log("sh delete API")
    console.log(name)
    console.log(payload)
    const url = `${getLocationOrigin(2)}/${appConfig.sessionPlans.data.API}${appConfig.sessionPlans.data[name].path}/${payload}/`
  var options = {...defaultOptions, ...postMethod, ...multipartJsonHeader};
  options.method = 'delete';
  options.body = payload;
  console.log(options)
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const putSessionPlanData = (name, payload) => {
    console.log("sh put API ")
    console.log(name)
    console.log(payload)
    const url = `${getLocationOrigin(2)}/${appConfig.sessionPlans.data.API}${appConfig.sessionPlans.data[name].path}/${payload.id}/`
  var options = {...defaultOptions, ...postMethod, ...multipartJsonHeader};
  options.method = 'put';
  options.body = payload.formData;
  console.log(options)
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/sessionPlan.js